import SearchForm from "./pages/SearchForm";
import UpdateForm from "./pages/UpdateForm";
import { useEffect, useRef, useState } from "react";
import { message, Modal } from "antd";
import {
  changeMemberStatus,
  deleteMember,
  fetchMembers,
  updateMember,
} from "../../../api/member";
import { getStorageValByKey, STORAGE_KEY } from "../../../utils/storage";

export default function UserSearch() {
  const [isUpdateFormVisible, setIsUpdateFormVisible] = useState(false);
  const [data, setData] = useState(null);
  const [editingRecord, setEditingRecord] = useState(null);
  const [pagination, setPagination] = useState({
    page_no: 1,
    page_size: 10,
    total: 0,
  });
  const [searchParam, setSearchParam] = useState({});

  const parseRoleId = (roleId) => {
    if (roleId === "1") return "高级管理员";
    if (roleId === "2") return "智慧豆录入员";
    if (roleId === "3") return "智慧豆审核员";
    if (roleId === "4") return "智慧豆录入和审核员";
    return "未知权限";
  };

  const parseStatus = (status) => {
    if (status === 1) return "已启用";
    if (status === 0) return "未启用";
    return "未知状态";
  };

  const parseToFormattedDate = (timestamp) => {
    if (timestamp === undefined || timestamp === null) return null;
    const date = new Date(timestamp);

    // 加8小时
    date.setHours(date.getHours() + 8);

    return date.toISOString().replace("T", " ").slice(0, 19);
  };

  const permissionIdList = useRef([]);
  useEffect(() => {
    permissionIdList.current = getStorageValByKey(STORAGE_KEY.permissionList);
  }, []);

  // Fetch data whenever pagination changes
  useEffect(() => {
    handleSearch(searchParam);
  }, [pagination.page_no, pagination.page_size]);

  const fetchData = (
    nick_name,
    phone_no,
    user_no,
    role_id,
    status,
    start_time,
    end_time
  ) => {
    fetchMembers(
      pagination.page_no,
      pagination.page_size,
      nick_name || "",
      phone_no || "",
      user_no || "",
      role_id || "",
      status === undefined ? "" : status,
      start_time || "",
      end_time || ""
    )
      .then((response) => {
        const { list, count } = response.data;
        setData(list);
        setPagination((prevPagination) => ({
          ...prevPagination,
          total: count,
        }));
      })
      .catch((error) => {
        message.error("Failed to fetch members.");
      });
  };

  const handleCancel = () => {
    setEditingRecord(null);
    setIsUpdateFormVisible(false);
  };

  const handleUpdate = (values) => {
    updateMember(
      values.user_no,
      values.nick_name,
      values.phone_no,
      values.role_id
    ).then((res) => {
      if (res.code === 0) {
        message.success("修改成功", 2);
        setTimeout(() => {
          handleSearch(searchParam);
        }, 1000);
      } else {
        message.error(`修改失败：${res.info || "未知错误"}`, 3);
      }
      setIsUpdateFormVisible(false);
      setEditingRecord(null);
    });
  };

  const handleDelete = (record) => {
    console.log("record", record.userNo);
    Modal.confirm({
      title: "确认删除",
      content: (
        <div className="modal-content">
          <p>
            确认删除学号为 <b>{record.user_no}</b>
          </p>
          <p>
            昵称为 <b>{record.nick_name}</b>
          </p>
          <p>
            权限为 <b>{parseRoleId(record.role_id)}</b>
          </p>
          <p>
            状态为 <b>{parseStatus(record.status)}</b> 的记录
          </p>
        </div>
      ),
      onOk() {
        deleteMember(record.user_no).then((res) => {
          if (res.code === 0) {
            message.success("删除成功", 2);

            setTimeout(() => {
              handleSearch(searchParam);
            }, 1000);
          } else {
            message.error(`删除失败：${res.info || "未知错误"}`, 3);
          }
        });
      },
    });
  };

  const changeStatus = (record, newStatus) => {
    Modal.confirm({
      title: "改变状态",
      content: (
        <div className="modal-content">
          <p>
            确认改变学号为 <b>{record.user_no}</b>
          </p>
          <p>
            昵称为 <b>{record.nick_name}</b>
          </p>
          <p>
            权限为 <b>{parseRoleId(record.role_id)}</b>
          </p>
          <p>
            状态为 <b>{parseStatus(record.status)}</b> 的状态
          </p>
          <p>
            为 <b>{parseStatus(newStatus)}</b>
          </p>
        </div>
      ),
      onOk() {
        changeMemberStatus(record.user_no, newStatus).then((res) => {
          if (res.code === 0) {
            message.success("修改成功", 2);

            setTimeout(() => {
              handleSearch(searchParam);
            }, 1000);
          } else {
            message.error(`修改失败：${res.info || "未知错误"}`, 3);
          }
          setEditingRecord(null);
        });
      },
    });
  };

  const handleEdit = (record) => {
    setEditingRecord(record);
    setIsUpdateFormVisible(true);
  };

  const handleSearch = (searchParam) => {
    fetchData(
      searchParam.nick_name,
      searchParam.phone_no,
      searchParam.user_no,
      searchParam.role_id,
      searchParam.status,
      searchParam.mtime === undefined
        ? null
        : parseToFormattedDate(searchParam.mtime[0]),
      searchParam.mtime === undefined
        ? null
        : parseToFormattedDate(searchParam.mtime[1])
    );
  };

  const handleSearchForPageOne = (values) => {
    setSearchParam(values);
    if (pagination.page_no !== 1) {
      setPagination({ page_no: 1, page_size: 10, count: 0 });
    } else {
      handleSearch(values);
    }
  };

  return (
    <div>
      <SearchForm
        showAddMemberBtn={permissionIdList.current.indexOf("1003002") > -1}
        data={data}
        setData={setData}
        pagination={pagination}
        setPagination={setPagination}
        handleDelete={handleDelete}
        handleEdit={handleEdit}
        changeStatus={changeStatus}
        parseRoleId={parseRoleId}
        parseStatus={parseStatus}
        handleSearch={handleSearch}
        fetchData={fetchData}
        searchParam={searchParam}
        setSearchParam={setSearchParam}
        handleSearchForPageOne={handleSearchForPageOne}
      />
      {editingRecord && (
        <UpdateForm
          key={editingRecord.user_no}
          isModalVisible={isUpdateFormVisible}
          handleUpdate={handleUpdate}
          handleCancel={handleCancel}
          editingRecord={editingRecord}
        />
      )}
    </div>
  );
}
